import { ProjectSearchCard } from '@platform/client/schemas';
import { Icon } from '@platform/components';

type ProjectCardProps = {
  project: ProjectSearchCard;
};

export const ProjectCard = (props: ProjectCardProps) => {
  const { location, name, roleType, image, id, organizationName } = props.project;

  return (
    <a
      className='min-w-[300px] min-h-[450px] flex flex-col bg-white shadow-md rounded-md cursor-pointer'
      href={`/platform/directory/projects/${id}`}
      target='_blank'
    >
      <img src={image ?? ''} className='w-full h-1/2 rounded-md object-contain' />
      <div className='w-full h-1/2 flex flex-col justify-between border-t border-gray-100 gap-3 p-6'>
        <div>
          <div className='flex flex-row gap-1'>
            <Icon type='users-02' size='19' />
            <div className='align-bottom'>{roleType.toLocaleUpperCase()}</div>
          </div>
          <div className='font-semibold text-xl/[24px] text-gray-500 pb-4'>{name}</div>
          {roleType === 'coach' && (
            <div className=' text-sm text-gray-700'>
              Provide {organizationName} with coaching support
            </div>
          )}
          {roleType === 'doer' && (
            <div className=' text-sm text-gray-700'>
              Work with {organizationName} to execute project tasks
            </div>
          )}
          {roleType === 'trainer' && (
            <div className=' text-sm text-gray-700'>
              Provide {organizationName} with training support
            </div>
          )}
          {roleType === 'mentor' && (
            <div className=' text-sm text-gray-700'>
              Provide {organizationName} with mentoring support
            </div>
          )}
          {roleType !== 'coach' &&
            roleType !== 'doer' &&
            roleType !== 'trainer' &&
            roleType !== 'mentor' && (
              <div className=' text-sm text-gray-700'>
                Support {organizationName} as a consultant
              </div>
            )}
        </div>
        <div>
          <div className='flex flex-row gap-3 items-center'>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='marker-pin-01' size='19' />
              <div className='text-sm'>{location}</div>
            </div>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='monitor-01' size='19' />
              <div className='text-sm'>Remote</div>
            </div>
            <div className='flex flex-col justify-center items-center gap-1 text-gray-400'>
              <Icon type='target-01' size='19' />
              <div className='text-sm'>SDG</div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
